import { toast } from "sonner";
import request from "../../helpers/request";

const registerUser = async (dataRequest: any) => {
  delete dataRequest.lojas;
  const url = `/Usuario`;
  console.log("dataRequest", dataRequest);
  const { data } = await request({
    url,
    method: "post",
    data: {
      ...dataRequest,
      idLoja: Number(dataRequest.idLoja),
      nivel: Number(dataRequest.nivel),
      idCliente: Number(dataRequest.idCliente),
    },
  });

  console.log("data", data);

  if (data === "ok") {
    toast.success("Usuário cadastrado com sucesso");
    return data;
  } else {
    let errorMessage = data.trim();

    if (errorMessage.startsWith("Erro - ")) {
      errorMessage = errorMessage.replace("Erro - ", "");
    }

    toast.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export const updateUser = async (dataRequest: any) => {
  const url = `/Usuario/${dataRequest.id}`;
  console.log("dataRequest", dataRequest);
  const response = await request({
    url,
    method: "put",
    data: {
      ...dataRequest,
      idLoja: Number(dataRequest.idLoja),
    },
  });

  if (response.data === "ok") {
    return response.data;
  } else {
    const errorMessage = response.data.trim();
    throw new Error(errorMessage);
  }
};

export const deleteUser = async (id: any) => {
  const url = `/Usuario/Excluir/${id}`;
  const { data } = await request({ url, method: "put" });

  if (data === "ok") {
    return data;
  } else {
    const error = data.split("Erro - ").filter((item: any) => item !== " ");
    throw new Error(error);
  }
};

export const resetUser = async (dataRequest: any) => {
  const url = `/Usuario/ResetUsuario/${dataRequest.id}`;
  const { data } = await request({
    url,
    method: "put",
    data: {
      ...dataRequest,
      contatoAlerta: "",
      emailAlerta: "",
      idLoja: Number(dataRequest.idLoja),
    },
  });

  if (data === "ok") {
    return data;
  } else {
    const error = data.split("Erro - ").filter((item: any) => item !== " ");
    throw new Error(error);
  }
};

export default registerUser;
